import { createStyled } from '@mui/system';

import defaultTheme from './theme-transponder';

export const mdStyled = createStyled({ defaultTheme });
